import { render, staticRenderFns } from "./flipclock.vue?vue&type=template&id=0f10c0f1&"
import script from "./flipclock.vue?vue&type=script&lang=js&"
export * from "./flipclock.vue?vue&type=script&lang=js&"
import style0 from "./flipclock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "flipclock.vue"
export default component.exports